import React, { useRef } from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import "../styles/Header.css";
import logo from "../assets/pmjsolutionlogo.png";

const Header = () => {
  const collapseRef = useRef();

  const handleNavLinkClick = () => {
    const toggleBtn = document.querySelector(".navbar-toggler");
    const collapseEl = collapseRef.current;
    if (toggleBtn && collapseEl?.classList.contains("show")) {
      toggleBtn.click();
    }
  };

  return (
    <header className="site-header">
      <Navbar expand="lg" className="custom-navbar">
        {/* fluid + px-0 for true full-bleed header */}
        <Container fluid className="px-0">
          <Navbar.Brand
            href="/"
            className="brand-container"
            onClick={handleNavLinkClick}
          >
            <img
              src={logo}
              alt="PMJ Logistics Solutions"
              className="brand-logo"
              loading="eager"
              decoding="async"
              draggable="false"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbar-nav" />

          <Navbar.Collapse id="navbar-nav" ref={collapseRef}>
            <Nav className="ms-auto">
              <Nav.Link href="#about-us" onClick={handleNavLinkClick}>
                About Us
              </Nav.Link>
              <Nav.Link href="#portfolio" onClick={handleNavLinkClick}>
                Portfolio
              </Nav.Link>
              <Nav.Link href="#testimonials" onClick={handleNavLinkClick}>
                Testimonials
              </Nav.Link>
              <Nav.Link href="#contact" onClick={handleNavLinkClick}>
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
